import React from 'react';
import slug from 'slug';
import Lightbox from 'react-images';

import './GalleryContent.scss';

import allImages from '../../../assets/img/llc/surgery/procedures';
import specialImages from '../../../assets/img/llc/special';

class GalleryContent extends React.Component {
    constructor(props) {
        super();

        this.state = {
            lightboxIsOpen: false,
            currentImage: 0,
        }
    }

    gotoPrevious = () => {
        this.setState({
            currentImage: this.state.currentImage - 1,
        });
    };

    openLightbox = (event) => {
        event.preventDefault();
        this.setState({
            currentImage: parseInt(event.currentTarget.id),
            lightboxIsOpen: true,
        });
    };

    gotoNext = () => {
        this.setState({
            currentImage: this.state.currentImage + 1,
        });
    };

    closeLightbox = () => {
        this.setState({
            currentImage: 0,
            lightboxIsOpen: false,
        });
    };

    componentDidMount() {
        this.setState({
            loading: false
        })
    }

    getSlugs = () => {
        const {surgery, activeProcedure} = this.props;
        const surgerySlag = slug(surgery.name, {lower: true});
        const procedure = surgery.procedures.find(proc => proc.id === parseInt(activeProcedure));
        const procedureSlag = slug(procedure.name, {lower: true});

        return {
            surgerySlag,
            procedureSlag
        }
    };

    renderLightBox = () => {
        const {images, error} = this.imagesObjects();
        if (error) return <span/>;

        let imagesArray = [];

        Object.keys(images)
          .sort((key1, key2) => (parseInt(key1.substr(1)) > parseInt(key2.substr(1))) ? 1 : -1)
          .forEach((key, index) => {
            const img = images[key];

            imagesArray.push({src: img.before, caption: "PŘED"});
            imagesArray.push({src: img.after, caption: "PO"});
        });

        return (
            <Lightbox
                currentImage={this.state.currentImage}
                images={imagesArray ? imagesArray : []}
                isOpen={this.state.lightboxIsOpen}
                onClickPrev={this.gotoPrevious}
                onClickNext={this.gotoNext}
                onClose={this.closeLightbox}
            />
        )
    };

    imagesObjects = () => {
        const {surgerySlag, procedureSlag} = this.getSlugs();

        let returnObject = {
            images: {},
            imagesTn: {},
            error: true
        };

        if (!allImages[surgerySlag].full) return returnObject;
        returnObject.images = allImages[surgerySlag].full[procedureSlag];
        returnObject.imagesTn = allImages[surgerySlag].tn[procedureSlag];
        if (!returnObject.images) return returnObject;

        returnObject.error = false;
        return returnObject;
    };

    getImages = () => {
        const {surgerySlag, procedureSlag} = this.getSlugs();
        if (!allImages[surgerySlag].full) return false;
        return allImages[surgerySlag].full[procedureSlag];
    };

    renderImages = () => {
        const {images, imagesTn, error} = this.imagesObjects();
        if (error) return <span/>;

        let imgIndex = 0;

        return Object.keys(images)
          .sort((key1, key2) => (parseInt(key1.substr(1)) > parseInt(key2.substr(1))) ? 1 : -1)
          .map((key, index) => {

            const bundle = (imagesTn && imagesTn[key]) ? imagesTn[key] : images[key];

            return (
                <div className="col-12 galleryContent_item_col" key={index}>
                    <div className="galleryContent_item_wrap clearfix">
                        <div className="galleryContent_item" id={imgIndex++}
                             onClick={this.openLightbox.bind(this)}>
                            <div className="galleryContent_item_img"><img src={bundle.before}/></div>
                        </div>
                        <div className="galleryContent_item" id={imgIndex++}
                             onClick={this.openLightbox.bind(this)}>
                            <div className="galleryContent_item_img"><img src={bundle.after}/></div>
                        </div>
                    </div>
                </div>
            )
        })
    };

    renderSpecialLightBox = () => {
        const slugs = this.getSlugs();
        if (slugs.procedureSlag === "laserove-beleni-zubu") {
            let returnObject = {
                images: specialImages["laserove-beleni-zubu"],
                error: false
            };

            let imagesArray = [];

            Object.keys(returnObject.images).forEach((key, index) => {
                const img = returnObject.images[key];

                imagesArray.push({src: img});
            });

            return (
                <Lightbox
                    currentImage={this.state.currentImage}
                    images={imagesArray ? imagesArray : []}
                    isOpen={this.state.lightboxIsOpen}
                    onClickPrev={this.gotoPrevious}
                    onClickNext={this.gotoNext}
                    onClose={this.closeLightbox}
                />
            )
        }
        else return <span/>
    };

    renderSpecialContent = () => {
        const slugs = this.getSlugs();
        if (slugs.procedureSlag === "laserove-beleni-zubu") {
            return specialImages["laserove-beleni-zubu"].map((img, index) => {
                return <div className="col-6 galleryContent_item_col special" key={index}>
                    <div className="galleryContent_item_wrap clearfix">
                        <div className="galleryContent_item"
                             id={index}
                             onClick={this.openLightbox.bind(this)}>
                            <div className="galleryContent_item_img"><img src={img}/></div>
                        </div>
                    </div>
                </div>
            });
        }
        else return <span/>
    };

    render() {
        const {surgery, activeProcedure} = this.props;
        const procedure = surgery.procedures.find(proc => proc.id === parseInt(activeProcedure));
        if (!procedure) {
            return (
                <section className="galleryContent" ref={this.props.setRef}>
                    <div className="galleryContent_container">
                        <div className="galleryContent_noImage">
                            Vyberte zákrok
                        </div>
                    </div>
                </section>
            )
        }


        return (
            <section className="galleryContent" ref={this.props.setRef}>
                <div className="galleryContent_container">
                    <h2 className="text-center">{procedure.name}</h2>

                    {this.getImages() &&
                    <div className="galleryContent_item_row row">
                        <div className="col-12 galleryContent_item_col">
                            <div className="galleryContent_item_wrap clearfix">
                                <div className="galleryContent_item">
                                    <div className="galleryContent_item_title">Před Zákrokem</div>
                                </div>
                                <div className="galleryContent_item">
                                    <div className="galleryContent_item_title">Po Zákroku</div>
                                </div>
                            </div>
                        </div>

                        {this.renderImages()}
                    </div>
                    }

                    {(!this.getImages() && slug(procedure.name, {lower: true}) !== "laserove-beleni-zubu") &&
                    <div className="galleryContent_noImage">
                        Pro tuto kategorii nejsou žádné obrázky
                    </div>
                    }

                    <div className="galleryContent_item_row row">
                        {this.renderSpecialContent()}
                    </div>
                </div>

                {this.getImages() && this.renderLightBox()}
                {!this.getImages() && this.renderSpecialLightBox()}
            </section>
        );
    }
}

export default GalleryContent;



// WEBPACK FOOTER //
// ./src/components/Gallery/GalleryContent/GalleryContent.js